import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { Specialty, SpecialtyPlanConsultation } from '../dto/specialty.dto';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class SpecialtyPlansService {
  private readonly urlV2 = environment.api_v2;
  constructor(private readonly apiService: ApiServiceService, private readonly http: HttpClient) {}

  findAll(): Observable<{ list: SpecialtyPlanConsultation[]; total: number }> {
    return this.apiService.get(`/specialty-plans`);
  }

  public getById(id: number): Observable<Specialty> {
    return this.http.get<Specialty>(`${this.urlV2}/v2/specialty/${id}`);
  }
}
